import { render, staticRenderFns } from "./recomPullNew.vue?vue&type=template&id=5a242882&scoped=true&"
import script from "./recomPullNew.vue?vue&type=script&lang=js&"
export * from "./recomPullNew.vue?vue&type=script&lang=js&"
import style0 from "./recomPullNew.vue?vue&type=style&index=0&id=5a242882&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a242882",
  null
  
)

export default component.exports